import { Link } from "react-router-dom";
import { Instagram, Twitter, ChevronUp, Gamepad2 } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="border-t border-primary/20 bg-background">
      {/* Back to top */}
      <button
        onClick={scrollToTop}
        className="flex w-full items-center justify-center gap-2 bg-secondary py-3 text-xs font-bold uppercase tracking-wider text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary"
      >
        <ChevronUp className="h-4 w-4" /> Back to top
      </button>

      <div className="container mx-auto px-4 py-12">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-5">
          <div className="sm:col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 font-display text-xl font-black">
              <Gamepad2 className="h-5 w-5 text-primary" />
              <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">GROVEFAN</span>
            </Link>
            <p className="mt-3 text-xs text-muted-foreground">Bold gaming streetwear for the next generation. Built different.</p>
            <div className="mt-3 flex gap-2">
              <a href="https://www.instagram.com/grovefanreal?igsh=ZWJ6bW4wdWFyd2hx" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-md border border-border p-2 transition-colors hover:border-primary hover:text-primary">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://x.com/grovefanreal" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="rounded-md border border-border p-2 transition-colors hover:border-primary hover:text-primary">
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-[10px] font-bold uppercase tracking-widest text-primary">Shop</h3>
            <div className="mt-3 flex flex-col gap-1.5">
              <Link to="/shop" className="text-xs text-muted-foreground hover:text-foreground">All Products</Link>
              <Link to="/shop" className="text-xs text-muted-foreground hover:text-foreground">New Arrivals</Link>
              <Link to="/shop" className="text-xs text-muted-foreground hover:text-foreground">Best Sellers</Link>
              <Link to="/shop?sort=price-low" className="text-xs text-muted-foreground hover:text-foreground">Deals</Link>
            </div>
          </div>
          <div>
            <h3 className="text-[10px] font-bold uppercase tracking-widest text-primary">Categories</h3>
            <div className="mt-3 flex flex-col gap-1.5">
              <Link to="/shop?cat=Hoodies" className="text-xs text-muted-foreground hover:text-foreground">Hoodies</Link>
              <Link to="/shop?cat=T-Shirts" className="text-xs text-muted-foreground hover:text-foreground">T-Shirts</Link>
              <Link to="/shop?cat=Pants" className="text-xs text-muted-foreground hover:text-foreground">Pants</Link>
              <Link to="/shop?cat=Jackets" className="text-xs text-muted-foreground hover:text-foreground">Jackets</Link>
            </div>
          </div>
          <div>
            <h3 className="text-[10px] font-bold uppercase tracking-widest text-primary">Company</h3>
            <div className="mt-3 flex flex-col gap-1.5">
              <Link to="/about" className="text-xs text-muted-foreground hover:text-foreground">About Us</Link>
              <Link to="/contact" className="text-xs text-muted-foreground hover:text-foreground">Contact</Link>
              <Link to="/sell" className="text-xs font-semibold text-primary hover:text-accent">Start Selling</Link>
            </div>
          </div>
          <div>
            <h3 className="text-[10px] font-bold uppercase tracking-widest text-primary">Support</h3>
            <div className="mt-3 flex flex-col gap-1.5">
              <Link to="/shipping-returns" className="text-xs text-muted-foreground hover:text-foreground">Shipping & Returns</Link>
              <Link to="/faq" className="text-xs text-muted-foreground hover:text-foreground">FAQ</Link>
              <Link to="/size-guide" className="text-xs text-muted-foreground hover:text-foreground">Size Guide</Link>
              <Link to="/privacy" className="text-xs text-muted-foreground hover:text-foreground">Privacy Policy</Link>
              <Link to="/terms" className="text-xs text-muted-foreground hover:text-foreground">Terms of Service</Link>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-border/50 pt-6 text-center text-[10px] text-muted-foreground">
          © 2026 Grovefan. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
